import { useTranslation } from 'react-i18next';
import ToolbarMenuItem from 'features/toolbar/ToolbarMenuItem/ToolbarMenuItem';
import { useParticipantsControl } from 'features/toolbar/toolbar/controls/participants/useParticipantsControl';
import React from 'react';
import { ToolbarMenuItemWrapperProps } from 'features/toolbar/types';

const ParticipantsControl = ({ onClick }: ToolbarMenuItemWrapperProps) => {
  const { t } = useTranslation('room');

  const {
    active,
    icon,
    togglePanel,
    totalParticipants,
    isFeatureAvailable,
    canSeeParticipantsPanel,
  } = useParticipantsControl();

  if (!isFeatureAvailable) {
    return null;
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(event);
    togglePanel();
  };

  if (!canSeeParticipantsPanel) {
    return (
      <ToolbarMenuItem
        id="participants"
        overlay={t('toolbar.breakout_rooms')}
        ariaLabel={t('toolbar.breakout_rooms')}
        icon={icon}
        active={active}
        onClick={handleClick}
      />
    );
  }

  return (
    <ToolbarMenuItem
      id="participants"
      overlay={t('toolbar.participants')}
      ariaLabel={t('toolbar.participants')}
      icon={icon}
      badgeContent={totalParticipants}
      active={active}
      onClick={handleClick}
    />
  );
};

export default ParticipantsControl;
